import { SALES_REPORTS_URL } from '../constants';
import { apiSlice } from './apiSlice';

const cleanParams = (params = {}) =>
    Object.fromEntries(
        Object.entries(params).filter(([, value]) => value !== '' && value !== undefined && value !== null)
    );

export const salesReportApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getSalesReportFilters: builder.query({
            query: () => ({
                url: `${SALES_REPORTS_URL}/filters`,
            }),
            providesTags: ['SalesReport'],
            keepUnusedDataFor: 300,
        }),
        getSalesReport: builder.query({
            query: (params = {}) => ({
                url: SALES_REPORTS_URL,
                params: cleanParams(params),
            }),
            providesTags: ['SalesReport'],
            keepUnusedDataFor: 30,
        }),
        getSalesReportOrders: builder.query({
            query: (params = {}) => ({
                url: `${SALES_REPORTS_URL}/orders`,
                params: cleanParams(params),
            }),
            providesTags: ['SalesReport'],
            keepUnusedDataFor: 30,
        }),
        getSalesReportProducts: builder.query({
            query: (params = {}) => ({
                url: `${SALES_REPORTS_URL}/products`,
                params: cleanParams(params),
            }),
            providesTags: ['SalesReport'],
            keepUnusedDataFor: 30,
        }),
    }),
});

export const {
    useGetSalesReportFiltersQuery,
    useGetSalesReportQuery,
    useGetSalesReportOrdersQuery,
    useGetSalesReportProductsQuery,
} = salesReportApiSlice;
